import {
  Button,
  Col,
  Input,
  Pagination,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from 'antd';
import React, { useState } from 'react';
import ActionButton from '../../../components/ActionButton';
import AddButton from '../../../components/AddButton';
import Confirm from '../../../components/Confirm';
import FormCreator from '../../../components/FormCreator';
import Typograpy from '../../../components/Typograpy';
import { useHideModal, useShowAlert, useShowModal } from '../../../hooks';
import { Container, AddContainer } from './style';
import {
  formData,
  initialValuesAdd,
  buttons,
  names,
  formDataType,
  initialValuesAddType,
  paymentPlantForm,
  paymentPlanInitial,
} from './helper';
import { useEffect } from 'react';
import ratingService from '../../../services/rating';
import ratingTypeService from '../../../services/ratingtype';
import usersService from '../../../services/users';
import FullScreen from '../../../components/Spinner/FullScreen';
import CustomSelect from 'components/FormElements/Select';
import { useSelector } from 'react-redux';
import Filters from '../../../components/Filters';
import DatePicker from 'react-multi-date-picker';
import weekendService from '../../../services/weekend';
import groupService from '../../../services/groups';
import regionService from '../../../services/regions';
import tggroupService from '../../../services/tggroup';
import macaddressService from '../../../services/macaddress';
import './style.css';
import paymentPlanService from 'services/paymentPlan';

export default () => {
  const { Title } = Typography;
  const { Option } = Select;
  const { userId } = useSelector((state) => state.authReducer);
  const [rates, setRates] = useState([]);
  const [ratesType, setRatesType] = useState([]);
  const [province, setProvince] = useState([]);
  const [active, setActive] = useState('rate');
  const [bool, setBool] = useState([]);
  const [boolType, setBoolType] = useState(true);
  const [loading, setLoading] = useState(false);
  const [weekend, setWeekend] = useState({});
  const [weekends, setWeekends] = useState([]);
  const [groups, setGroups] = useState([]);
  const [regions, setRegions] = useState([]);
  // const [group, setGroup] = useState('');
  // const [telegram, setTelegram] = useState('');
  // const [telegramGroup, setTelegramGroup] = useState([]);
  const [paymentPlan, setPaymentPlan] = useState([]);
  const [macData, setMacData] = useState([]);
  const [postData, setPostData] = useState({});
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const { success, error } = useShowAlert();

  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();

  const handleActive = (item) => {
    setActive(item.value);
  };

  useEffect(() => {
    groupService.getAll().then((res) => {
      setGroups(res);
    });
    regionService.getAll().then((res) => {
      setRegions(res);
    });
  }, []);

  useEffect(() => {
    if (groups.length) {
      const data = { group: postData?.group || groups[0]?._id };
      setLoading(true);
      ratingService
        .getAll(data)
        .then((res) => {
          let user = res.map((item, index) => {
            return { ...item, group: item.group?.title ?? '', key: index + 1 };
          });
          setRates(user);
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [bool, postData, groups]);

  useEffect(() => {
    setLoading(true);
    ratingTypeService
      .getAll()
      .then((res) => {
        let data = res.map((item, index) => {
          return {
            key: index + 1,
            _id: item?._id,
            title: item?.title,
            range: `${item.startRange}-${item.endRange}`,
          };
        });
        setRatesType(data);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
    paymentPlanService
      .getAll()
      .then((res) => {
        setPaymentPlan(() => res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [boolType]);

  useEffect(() => {
    usersService
      .getOne(userId)
      .then((res) => {
        setProvince(res?.province);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    fetchWeekendData();
  }, []);

  // useEffect(() => {
  //   tggroupService.getAll().then((res) => {
  //     setTelegramGroup(res);
  //   });
  // }, []);

  // MacAdress
  useEffect(() => {
    let data = {
      ...postData,
    };
    if (active === 'macaddress') {
      setLoading(true);
      data = { ...data, page: page, limit: size };
      macaddressService
        .getAll(data)
        .then(({ docs, totalDocs, page }) => {
          setPage(page);
          setTotal(totalDocs);
          let data = docs?.map((item) => {
            return {
              // key: index + 1,
              region: item?.region.title,
              group: item?.group[0]?.title,
              fullName: item?.lastName + ' ' + item?.firstName,
              count: item?.macAddress?.length,
            };
          });
          setMacData(data);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    }
  }, [postData, active, page, size]);

  // useEffect(() => {
  //   let data = telegramGroup.find((item) => item.group == group);
  //   setTelegram(data?.telGroupId);
  // }, [group]);

  const fetchWeekendData = () => {
    weekendService.getOne().then((res) => {
      setWeekends(res);
    });
  };

  // Create
  const sendData = (data) => {
    let newData = { ...data, province: province };
    hideModal();
    setLoading(true);
    ratingService
      .create(newData)
      .then(() => {
        setBool(!bool);
        success('Баҳолаш кўрсаткичи сақланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Баҳолаш кўрсаткичини сақлашда хатолик', 2, 'bottom');
      });
  };
  const addUser = () => {
    showBlured({
      title: 'Баҳолаш кўрсаткичини қўшиш',
      maxWidth: '650px',
      height: '600px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={formData}
          cancel={hideModal}
          sendData={sendData}
          selectOptions={{ group: groups }}
          id=''
          initialVal={initialValuesAdd}
        />
      ),
    });
  };

  const sendTypeData = (data) => {
    hideModal();
    setLoading(true);
    ratingTypeService
      .create(data)
      .then(() => {
        setBoolType(!boolType);
        success('Баҳолаш тури сақланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Баҳолаш турини сақлашда хатолик', 2, 'bottom');
      });
  };

  const addType = () => {
    showBlured({
      title: 'Баҳолаш турини қўшиш',
      maxWidth: '650px',
      height: '600px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={formDataType}
          cancel={hideModal}
          sendData={sendTypeData}
          // selectOptions={}
          id=''
          initialVal={initialValuesAddType}
        />
      ),
    });
  };

  const addPayPlan = (data) => {
    hideModal();
    setLoading(true);
    paymentPlanService
      .create(data)
      .then(() => {
        setBoolType(!boolType);
        success('Тўлов тарифи сақланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Тўлов тарифини сақлашда хатолик', 2, 'bottom');
      });
  };
  const addPaymentPlan = () => {
    showBlured({
      title: 'Тўлов тарифи қўшиш',
      maxWidth: '650px',
      height: '600px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={paymentPlantForm}
          cancel={hideModal}
          sendData={addPayPlan}
          id=''
          initialVal={paymentPlanInitial}
        />
      ),
    });
  };

  // Update

  const initialValuesEdit = (data) => {
    return {
      title: data.title,
      rate: data.rate,
      group: data?.group,
    };
  };

  const updateData = (id, data) => {
    let newData = { ...data, province: province };
    hideModal();
    setLoading(true);
    ratingService
      .update(id, newData)
      .then(() => {
        setBool(!bool);
        success('Баҳолаш кўрсаткичини янгиланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Баҳолаш кўрсаткичини  янгилашда хатолик', 2, 'bottom');
      });
  };

  const handleEdit = (data) => {
    showBlured({
      title: 'Баҳолаш кўрсаткичини  таҳрирлаш',
      maxWidth: '650px',
      height: '600px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={formData}
          cancel={hideModal}
          sendData={updateData}
          selectOptions={{ group: groups }}
          id={data._id}
          initialVal={initialValuesEdit(data)}
        />
      ),
    });
  };

  const initialValuesEditType = (data) => {
    let rang = data.range.split('-');
    return {
      _id: data._id,
      title: data.title,
      startRange: rang[0] * 1,
      endRange: rang[1] * 1,
    };
  };

  const updateDataType = (id, data) => {
    hideModal();
    setLoading(true);
    ratingTypeService
      .update(id, data)
      .then(() => {
        setBoolType(!boolType);
        success('Баҳолаш тури янгиланди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Баҳолаш турини  янгилашда хатолик', 2, 'bottom');
      });
  };

  const handleEditType = (data) => {
    showBlured({
      title: 'Баҳолаш турини  таҳрирлаш',
      maxWidth: '650px',
      height: '600px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={formDataType}
          cancel={hideModal}
          sendData={updateDataType}
          // selectOptions={sections}
          id={data._id}
          initialVal={initialValuesEditType(data)}
        />
      ),
    });
  };

  const updatePayPlan = (data) => {
    hideModal();
    setLoading(true);
    const id = data?._id;
    if (id) {
      delete data['_id'];
      paymentPlanService
        .update(id, data)
        .then(() => {
          setBoolType(!boolType);
          success('Тўлов тарифи янгиланди', 2, 'bottom');
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          error('Тўлов тарифини  янгилашда хатолик', 2, 'bottom');
        });
    } else {
      error('Тўлов тарифини  янгилашда хатолик', 2, 'bottom');
    }
  };

  const updatePaymentPlan = (data) => {
    showBlured({
      title: 'Тўлов тарифи қўшиш',
      maxWidth: '650px',
      height: '600px',
      withHeader: false,
      body: () => (
        <FormCreator
          formData={paymentPlantForm}
          cancel={hideModal}
          sendData={updatePayPlan}
          id=''
          initialVal={{
            term: data.term,
            price: data.price,
            _id: data._id,
          }}
        />
      ),
    });
  };

  // Delete

  const deleteUser = (id) => {
    hideModal();
    setLoading(true);
    ratingService
      .delete(id)
      .then(() => {
        setBool(!bool);
        success('Баҳолаш кўрсаткичини ўчирилди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Баҳолаш кўрсаткичини ўчиришда хатолик', 2, 'bottom');
      });
  };

  const handleDelete = (data) => {
    showBlured({
      title: "O'chirish",
      maxWidth: '400px',
      height: '300px',
      withHeader: false,
      body: () => <Confirm agree={() => deleteUser(data)} cancel={hideModal} />,
    });
  };

  const deleteType = (id) => {
    hideModal();
    setLoading(true);
    ratingTypeService
      .delete(id)
      .then(() => {
        setBoolType(!boolType);
        success('Баҳолаш тури ўчирилди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Баҳолаш турини ўчиришда хатолик', 2, 'bottom');
      });
  };

  // delete payment plan
  const handleDeleteType = (data) => {
    showBlured({
      title: "O'chirish",
      maxWidth: '400px',
      height: '300px',
      withHeader: false,
      body: () => <Confirm agree={() => deleteType(data)} cancel={hideModal} />,
    });
  };
  const deletePaymentPlan = (id) => {
    hideModal();
    setLoading(true);
    paymentPlanService
      .delete(id)
      .then(() => {
        setBoolType(!boolType);
        success('Тўлов тарифи ўчирилди', 2, 'bottom');
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        error('Тўлов тарифини ўчиришда хатолик', 2, 'bottom');
      });
  };
  const handleDeletePayPlan = (data) => {
    showBlured({
      title: "O'chirish",
      maxWidth: '400px',
      height: '300px',
      withHeader: false,
      body: () => (
        <Confirm agree={() => deletePaymentPlan(data)} cancel={hideModal} />
      ),
    });
  };

  const getTotalRate = (data) => {
    let total = data.reduce((tot, item) => {
      return tot + item.rate * 1;
    }, 0);
    return total;
  };

  const handleWorkday = () => {
    const data = {
      day: weekend.days * 1,
      holidays: weekend.holidays,
      group: weekend.group,
    };
    setLoading(true);
    let isUpdate = weekends.find((item) => item.group == data.group);
    isUpdate
      ? weekendService
          .update(isUpdate._id, data)
          .then(() => {
            fetchWeekendData();
          })
          .finally(() => {
            setWeekend({});
            setLoading(false);
          })
      : weekendService
          .create(data)
          .then(() => {
            fetchWeekendData();
          })
          .finally(() => {
            setWeekend({});
            setLoading(false);
          });
  };

  // const handleTelegramId = () => {
  //   let sendData = {
  //     group: group,
  //     telGroupId: telegram,
  //   };
  //   setLoading(true);
  //   let data = telegramGroup.find((e) => e.group === group);

  //   if (data && 'group' in data) {
  //     tggroupService
  //       .update(data?._id, sendData)
  //       .then((res) => {
  //         let foo = telegramGroup.map(
  //           (item) => [res].find((itm) => itm.group === item.group) || item
  //         );
  //         setTelegramGroup(foo);
  //         setTelegram('');
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   } else {
  //     tggroupService
  //       .create(sendData)
  //       .then((res) => {
  //         let foo = telegramGroup.map((item) => item);
  //         foo.push(res);
  //         setTelegramGroup(foo);
  //         setTelegram('');
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }
  // };

  const columns = [
    {
      title: '№',
      dataIndex: 'key',
      key: 'key',
      align: 'center',
      width: '10%',
      render: (id, item, index) => {
        let pageNumber = page > 1 ? page * size + index - size : ++index;
        return pageNumber;
      },
    },
    {
      title: 'Гуруҳ',
      dataIndex: 'group',
      key: 'group',
      width: '10%',
      align: 'center',
    },
    {
      title: 'Изоҳ',
      dataIndex: 'title',
      key: 'title',
      width: '60%',
    },
    {
      title: 'Балл',
      dataIndex: 'rate',
      align: 'center',
      key: 'rate',
      width: '10%',
    },

    {
      width: '15%',
      align: 'center',
      title: 'Амал',
      dataIndex: '',
      key: 'x',
      render: (props) => (
        <ActionButton
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          props={props}
        />
      ),
    },
  ];

  const columnsType = [
    {
      title: 'Номи',
      dataIndex: 'title',
      key: 'title',
      width: '50%',
    },
    {
      title: 'Оралиқ',
      dataIndex: 'range',
      align: 'center',
      key: 'range',
      width: '25%',
    },

    {
      width: '25%',
      align: 'center',
      title: 'Амал',
      dataIndex: '',
      key: 'x',
      render: (props) => (
        <ActionButton
          handleEdit={handleEditType}
          handleDelete={handleDeleteType}
          props={props}
        />
      ),
    },
  ];

  // const telegramColumns = [
  //   {
  //     title: '№',
  //     dataIndex: 'key',
  //     key: 'key',
  //     width: '10%',
  //     align: 'center',
  //   },
  //   {
  //     title: 'Гуруҳ',
  //     dataIndex: 'group',
  //     align: 'center',
  //     key: 'group',
  //     width: '45%',
  //   },
  //   {
  //     title: 'Телеграм ID',
  //     dataIndex: 'telegram',
  //     align: 'center',
  //     key: 'telegram',
  //     width: '45%',
  //   },
  // ];

  const weekdayColumns = [
    {
      title: '№',
      dataIndex: 'key',
      key: 'key',
      width: '10%',
      align: 'center',
    },
    {
      title: 'Гуруҳ',
      dataIndex: 'group',
      align: 'center',
      key: 'group',
      width: '20%',
    },
    {
      title: 'Ҳафталик иш куни',
      dataIndex: 'workdays',
      align: 'center',
      key: 'workdays',
      width: '20%',
    },
    {
      title: 'Kunlar',
      dataIndex: 'days',
      align: 'center',
      key: 'days',
      width: '50%',
    },
  ];

  const macColumns = [
    {
      title: '№',
      dataIndex: 'key',
      key: 'key',
      width: '10%',
      align: 'center',
      render: (id, item, index) => {
        let pageNumber = page > 1 ? page * size + index + 1 - size : ++index;
        return pageNumber;
      },
    },
    {
      title: 'Шаҳар (туман)',
      dataIndex: 'region',
      align: 'center',
      key: 'region',
      width: '20%',
    },

    {
      title: 'Гуруҳ',
      dataIndex: 'group',
      align: 'center',
      key: 'group',
      width: '20%',
    },
    {
      title: 'Гуруҳ Раҳбари',
      dataIndex: 'fullName',
      align: 'center',
      key: 'fullName',
      width: '45%',
    },
    {
      title: 'Soni',
      dataIndex: 'count',
      align: 'center',
      key: 'count',
      width: '45%',
    },
  ];
  const paymentTypeColumns = [
    {
      title: '№',
      dataIndex: 'key',
      key: 'key',
      width: '10%',
      align: 'center',
      render: (id, item, index) => {
        let pageNumber = page > 1 ? page * size + index : ++index;
        return pageNumber;
      },
    },
    {
      title: 'Тариф тури',
      dataIndex: 'ppt',
      align: 'center',
      key: 'ppt',
      width: '20%',
      render: (_, item) => {
        return <p style={{ margin: 0 }}>{item?.term}-ой</p>;
      },
    },
    {
      title: 'Муддати (ой)',
      dataIndex: 'term',
      align: 'center',
      key: 'term',
      width: '20%',
    },
    {
      title: 'Суммаси (UZS)',
      dataIndex: 'price',
      align: 'center',
      key: 'price',
      width: '30%',
    },
    {
      width: '15%',
      align: 'center',
      title: 'Амал',
      dataIndex: '',
      key: 'x',
      render: (props) => (
        <ActionButton
          handleEdit={updatePaymentPlan}
          handleDelete={handleDeletePayPlan}
          props={props}
        />
      ),
    },
  ];

  // const tableData = groups.map((item, index) => {
  //   return {
  //     key: index + 1,
  //     group: item.title,
  //     telegram: telegramGroup.find((itm) => itm.group == item._id)?.telGroupId,
  //   };
  // });

  const tableWeekdaysData = weekends?.map((item, index) => {
    return {
      key: index + 1,
      group: groups?.find((itm) => itm._id == item.group)?.title,
      workdays: item?.days.length,
      days: item.holidays?.map((itm, ind) => (
        <span
          key={ind + 1}
          style={{
            backgroundColor: '#f6ffed',
            color: '#389e0d',
            padding: '3px',
            border: 'solid #b7eb8f 1px',
          }}
        >
          {itm}
        </span>
      )),
    };
  });

  const selectGroup = (groupId) => {
    let data = weekends.find((item) => item.group == groupId);

    data
      ? setWeekend({
          ...weekend,
          group: groupId,
          days: data.days.length,
          holidays: data.holidays,
        })
      : setWeekend({ group: groupId });
  };

  const onShowSizeChange = (current, pageSize) => {
    setPage(1);
    setSize(pageSize);
  };

  const content = {
    rate: (
      <>
        <AddContainer align='space-between'>
          <Row gutter={5} align='content-center' justify='start'>
            <Col>
              <CustomSelect
                handleChange={(value) => {
                  setPostData({ ...postData, ['group']: value });
                  setPage(() => 1);
                }}
                name='group'
                options={groups}
                defaultVal={postData?.group || groups[0]?._id}
                title='Гуруҳ'
                placeholder='Гуруҳ'
                allowClear={false}
              />
            </Col>
          </Row>
          <AddButton text='Баҳолаш кўрсаткичини' addData={addUser} />
        </AddContainer>
        <Typograpy>{names[active]} </Typograpy>
        <Table
          bordered
          columns={columns}
          dataSource={rates}
          pagination={false}
        />
        <Space
          align='end'
          direction='vertical'
          style={{ fontSize: '20px', marginRight: '20%' }}
        >
          {' Жами балл:       ' + getTotalRate(rates)}
        </Space>
      </>
    ),
    ratetype: (
      <>
        <AddContainer align='end'>
          <AddButton text='Баҳолаш турини' addData={addType} />
        </AddContainer>
        <Typograpy>{names[active]} </Typograpy>
        <Table
          bordered
          columns={columnsType}
          dataSource={ratesType}
          pagination={false}
        />
        {/* <Space
          align="end"
          direction="vertical"
          style={{ fontSize: "20px", marginRight: "20%" }}
        >
          {" Жами балл:       " + getTotalRate(rates)}
        </Space> */}
      </>
    ),
    weekend: (
      <>
        <div className='wrap__container'>
          <Title level={5}>Гуруҳ танланг</Title>
          <Select
            defaultValue=''
            style={{ width: 200 }}
            allowClear
            onChange={(val) => selectGroup(val)}
          >
            {groups?.map((item, ind) => (
              <Option key={ind + 1} value={item._id}>
                {item.title}
              </Option>
            ))}
          </Select>
          <Title level={5}>Ҳафталик иш куни</Title>
          <Space className='h-42' style={{ width: '200px' }}>
            <Input
              width={30}
              placeholder=''
              value={weekend.days}
              onChange={(e) => setWeekend({ ...weekend, days: e.target.value })}
            />
          </Space>
          <Space
            style={{
              flexDirection: 'row',
            }}
          >
            <Title level={5}>Дам олиш кунлари</Title>
            <DatePicker
              shadow={false}
              weekend='highlight'
              FirstDayOfWeek='Monday'
              multiple
              value={weekend?.holidays ? weekend.holidays : null}
              onChange={(e) => {
                let data = e.map(
                  (item) =>
                    `${item.year}-${
                      item.month < 10 ? `0${item.month}` : item.month
                    }-${item.day < 10 ? `0${item.day}` : item.day}`
                );
                setWeekend({ ...weekend, holidays: data });
              }}
            />
          </Space>{' '}
          <Button type='primary' onClick={handleWorkday}>
            Белгилаш
          </Button>
        </div>
        <Table
          bordered
          columns={weekdayColumns}
          dataSource={tableWeekdaysData}
          pagination={false}
        />
      </>
    ),

    // telegram: (
    //   <>
    //     {' '}
    //     <div
    //       style={{
    //         marginTop: '50px',
    //         display: 'flex',
    //         flexDirection: 'row',
    //         alignItems: 'center',
    //         gap: '10px',
    //       }}
    //     >
    //       <Title level={3}>Гуруҳ танланг</Title>
    //       <Select
    //         defaultValue=''
    //         style={{ width: 200 }}
    //         allowClear
    //         onChange={(val) => setGroup(val)}
    //       >
    //         {groups?.map((item, ind) => (
    //           <Option key={ind + 1} value={item._id}>
    //             {item.title}
    //           </Option>
    //         ))}
    //       </Select>
    //       <Title level={3}>Телеграм id киритинг</Title>
    //       <Space className='h-42' style={{ width: '200px' }}>
    //         <Input
    //           width={50}
    //           placeholder=''
    //           value={telegram}
    //           onChange={(e) => setTelegram(e.target.value)}
    //         />
    //       </Space>
    //       <Button type='primary' onClick={handleTelegramId}>
    //         Белгилаш
    //       </Button>
    //     </div>
    //     <Table
    //       bordered
    //       columns={telegramColumns}
    //       dataSource={tableData}
    //       pagination={false}
    //     />
    //   </>
    // ),
    macaddress: (
      <>
        <Row gutter={5} align='content-center' justify='start'>
          {active === 'macaddress' && (
            <Col>
              <CustomSelect
                // status={mustBeSelect ? 'error' : ''}
                handleChange={(value) => {
                  setPostData({ ...postData, ['region']: value });
                  setPage(() => 1);
                }}
                options={regions}
                name='region'
                defaultVal={postData?.region || undefined}
                title='Шаҳар(туман)'
                placeholder='Шаҳар(туман)'
                allowClear={false}
              />
            </Col>
          )}
          {(active === 'macaddress' || active === 'rate') && (
            <Col>
              <CustomSelect
                handleChange={(value) => {
                  setPostData({ ...postData, ['group']: value });
                  setPage(() => 1);
                }}
                name='group'
                options={groups}
                defaultVal={postData?.group || undefined}
                title='Гуруҳ'
                placeholder='Шаҳар(туман)'
                allowClear={false}
              />
            </Col>
          )}
        </Row>
        <Typograpy>{names[active]} </Typograpy>
        <Table
          bordered
          columns={macColumns}
          dataSource={macData}
          pagination={false}
        />
        <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
          <Pagination
            total={total}
            current={page}
            defaultPageSize={size}
            showSizeChanger
            onChange={(current) => setPage(current)}
            onShowSizeChange={onShowSizeChange}
          />
        </div>
      </>
    ),
    paymentPlan: (
      <>
        <AddContainer align='end'>
          <AddButton text='Тўлов тарифи' addData={addPaymentPlan} />
        </AddContainer>

        <Typograpy>{names[active]} </Typograpy>
        <Table
          bordered
          columns={paymentTypeColumns}
          dataSource={paymentPlan}
          pagination={false}
        />
      </>
    ),
  };

  if (loading) return <FullScreen />;
  return (
    <>
      <Container>
        <Filters list={buttons} active={active} handleActive={handleActive} />

        {content[active]}
      </Container>
    </>
  );
};
